<script setup>
import ZoomableImage from '@/components/ZoomableImage.vue';

const props = defineProps({
    student: {
        type: Object,
        required: true,
    },
});

const links = props.student.links;
</script>

<template>
    <div class="flex space-x-2 items-center">
        <ZoomableImage :src="student.avatar_or_default" v-if="student.avatar_or_default" class="flex-none">
            <img
                class="relative z-30 inline-block h-10 w-10 rounded-full ring-2 ring-white"
                :src="student.avatar_or_default"
                alt="profile photo"
            />
        </ZoomableImage>
        <div>
            <div v-if="links">
                <span v-if="student.is_study_variable">*</span>
                <InertiaLink :href="links.show" class="text-indigo-500">
                    {{ student.full_name }}
                </InertiaLink>
            </div>
            <div v-else>
                <span v-if="student.is_study_variable">*</span>
                {{ student.full_name }}
            </div>
        </div>
    </div>
</template>
